import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";

export default function Hero() {
    return (
        <section id="why" data-testid="hero-section" className="relative bg-white border-b border-slate-200 scroll-mt-24">
            <div className="absolute inset-0 bg-grain opacity-60 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-24 md:pt-28 md:pb-32">
                <div className="max-w-3xl">
                    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-slate-200 bg-white text-xs font-medium text-slate-600">
                        <ShieldCheck size={14} className="text-slate-700" />
                        <span>Private rep network · Invite-curated</span>
                    </div>

                    <h1
                        data-testid="hero-headline"
                        className="font-display mt-6 text-5xl md:text-6xl lg:text-7xl font-semibold leading-[1.02] tracking-tighter text-slate-900"
                    >
                        Add to your bag.
                        <br />
                        <span className="text-slate-500">Expand your income.</span>
                    </h1>

                    <p
                        data-testid="hero-subheadline"
                        className="mt-6 text-lg md:text-xl text-slate-600 max-w-2xl leading-relaxed"
                    >
                        1099er connects experienced orthopedic and biologics reps with
                        complementary independent-line opportunities from companies and
                        distributors looking for trusted field access.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row gap-3">
                        <a
                            href="#join"
                            data-testid="hero-become-1099er-btn"
                            className="inline-flex items-center justify-center gap-2 bg-slate-900 text-white text-sm md:text-base font-medium px-7 py-3.5 rounded-md hover:bg-slate-800 transition-colors"
                        >
                            Schedule a Confidential Call
                            <ArrowRight size={16} />
                        </a>
                    </div>

                    <p
                        data-testid="hero-reassurance"
                        className="mt-4 text-sm text-slate-500 flex items-center gap-2"
                    >
                        <ShieldCheck size={13} className="text-slate-500" />
                        Free to join. Your relationships stay private.
                    </p>

                    <p className="mt-10 text-sm text-slate-500 max-w-xl">
                        Built for orthopedic reps, biologics reps, independent distributors,
                        and emerging medical device companies.
                    </p>
                </div>
            </div>
        </section>
    );
}
